/**
 * Travel Guide Loader Component
 * Placeholder loader that matches the travel guide data structure
 */

import React from 'react';
import { spacing, borders, backgroundColors } from '@/design-system/utils';

export const TravelGuideLoader: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[6],
        width: '100%',
      }}
    >
      {/* Best Time to Visit Loader */}
      <div
        style={{
          backgroundColor: backgroundColors.primary,
          borderRadius: borders.radius.lg,
          padding: spacing[4],
          display: 'flex',
          flexDirection: 'column',
          gap: spacing[3],
        }}
      >
        <div
          style={{
            width: '200px',
            height: '24px',
            backgroundColor: '#E7E5E4',
            borderRadius: '4px',
          }}
          className='animate-pulse'
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: spacing[2],
          }}
        >
          <div
            style={{
              width: '100%',
              height: '16px',
              backgroundColor: '#E7E5E4',
              borderRadius: '4px',
            }}
            className='animate-pulse'
          />
          <div
            style={{
              width: '90%',
              height: '16px',
              backgroundColor: '#E7E5E4',
              borderRadius: '4px',
            }}
            className='animate-pulse'
          />
        </div>
      </div>

      {/* Mode of Travel Loader */}
      <div
        style={{
          backgroundColor: backgroundColors.primary,
          borderRadius: borders.radius.lg,
          padding: spacing[4],
          display: 'flex',
          flexDirection: 'column',
          gap: spacing[3],
        }}
      >
        <div
          style={{
            width: '180px',
            height: '24px',
            backgroundColor: '#E7E5E4',
            borderRadius: '4px',
          }}
          className='animate-pulse'
        />
        <div
          style={{
            display: 'flex',
            gap: spacing[2],
          }}
        >
          {[1, 2, 3].map(i => (
            <div
              key={i}
              style={{
                width: '80px',
                height: '32px',
                backgroundColor: '#E7E5E4',
                borderRadius: '4px',
              }}
              className='animate-pulse'
            />
          ))}
        </div>
        <div
          style={{
            width: '100%',
            height: '60px',
            backgroundColor: '#E7E5E4',
            borderRadius: '4px',
          }}
          className='animate-pulse'
        />
      </div>

      {/* Info Pointers Loader */}
      {[1, 2, 3].map(sectionIndex => (
        <div
          key={sectionIndex}
          style={{
            backgroundColor: backgroundColors.primary,
            borderRadius: borders.radius.lg,
            padding: spacing[4],
            display: 'flex',
            flexDirection: 'column',
            gap: spacing[3],
          }}
        >
          <div
            style={{
              width: '200px',
              height: '24px',
              backgroundColor: '#E7E5E4',
              borderRadius: '4px',
            }}
            className='animate-pulse'
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: spacing[2],
            }}
          >
            {[1, 2, 3].map(itemIndex => (
              <div
                key={itemIndex}
                style={{
                  width: `${90 - itemIndex * 5}%`,
                  height: '16px',
                  backgroundColor: '#E7E5E4',
                  borderRadius: '4px',
                }}
                className='animate-pulse'
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
